import { render, staticRenderFns } from "./OutrasMarcacoes.vue?vue&type=template&id=65cf8e7f&"
import script from "./OutrasMarcacoes.vue?vue&type=script&lang=js&"
export * from "./OutrasMarcacoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports